import React, { useContext, useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import ContentLoader from "react-content-loader";
import { useNavigate } from "react-router-dom";

import AppContext from "../../../AppContext";

import { langComponent } from "../../../constants";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

//component
import StylishButton from "../../common/StylishButton";
import { ChoiceChip } from "../../common/ChoiceChip";

//style
import "../../../styles/landingPage/tendering.scss";

// Import Swiper styles
import "swiper/css";
import "swiper/css/bundle";

//image
import { ReactComponent as PlaySvg } from "../../../assets/icons/play.svg";
import { ReactComponent as ArrowRightSvg } from "../../../assets/workExchange/arrow-right-circle.svg";
import { ReactComponent as ArrowLeftSvg } from "../../../assets/workExchange/arrow-left-circle.svg";
import useTendering from "../../../hooks/useTendering";
import useUsers from "../../../hooks/useUsers";
import useCompanies from "../../../hooks/useCompanies";
import TenderingCard from "../../TenderingCard";

const tabs = [
  {
    name: "Design",
    value: 1,
  },
  {
    name: "Construction",
    value: 2,
  },
];

function Tendering({ onSeeMore }) {
  const { designStyles, getLang, isAuth, user } = useContext(AppContext);
  const navigate = useNavigate();
  const TranslationCommon = getLang(langComponent.common);

  const [selectedTab, setSelectedTab] = useState(1);
  const [datasource, setDatasource] = useState([]);
  const swiperRef = useRef(null);
  const { query } = useTendering();
  const { queryUsers } = useUsers();
  const { queryCompany } = useCompanies();

  const handleTabClick = (tabValue) => {
    setSelectedTab(tabValue);
  };

  const handleClickSeeMore = () => {
    onSeeMore();
    navigate("/tenderings");
  };

  const fetchData = async () => {
    const { _metadata, data } = await query(
      { category: selectedTab, active: true, deleted: false },
      1,
      10,
      null,
      { createdOn: -1 }
    );

    // * Get owner
    const userIds = data.map((u) => u.createdBy);
    const companyIds = data.map((u) => u.company).filter((d) => !!d);

    const [userResults, companyResults] = await Promise.allSettled([
      queryUsers({ _id: { $in: userIds } }, null, -1, {
        _id: 1,
        firstname: 1,
        surname: 1,
        avatar: 1,
        uri: 1,
      }),
      queryCompany({ _id: { $in: companyIds } }, null, -1, {
        _id: 1,
        logo: 1,
        name: 1,
      }),
    ]);

    setDatasource(
      data.map((d) => {
        // * Map company
        if (d.company) {
          const _company = companyResults.value.data.find(
            (company) => company._id === d.company
          );

          d.createdBy = {
            isCompany: true,
            uri: _company._id,
            avatar: _company.logo,
            name: _company.name,
          };

          return d;
        }

        // * Map user
        const _user = userResults.value.data.find(
          (user) => user._id === d.createdBy
        );

        d.createdBy = {
          isCompany: false,
          uri: _user.uri,
          avatar: _user.avatar,
          name: _user.firstname + " " + _user.surname ?? "",
        };

        return d;
      })
    );
  };

  useEffect(() => {
    fetchData();
  }, [selectedTab]);

  const skeletonLoader = () => {
    return (
      <div className="lp-tendering__list-banner ">
        <div className="lp-tendering__list-banner-active loader">
          <ContentLoader
            style={{
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
            }}
          >
            <rect x="0" y="0" rx={20} ry={20} width="100%" height="100%" />
          </ContentLoader>
        </div>
        <div className="lp-tendering__list-banner-next">
          <ContentLoader
            style={{
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
            }}
          >
            <rect x="0" y="0" rx={20} ry={20} width="100%" height="100%" />
          </ContentLoader>
        </div>
      </div>
    );
  };

  const skeletonLoaderDetail = () => {
    return (
      <div className="lp-tendering__list-content-detail loader">
        <div>Project type</div>
        <ContentLoader
          style={{
            top: 0,
            left: 0,
            width: "50%",
            height: 30,
          }}
        >
          <rect x="0" y="0" rx={5} ry={5} width="100%" height="100%" />
        </ContentLoader>
        <div>Scope of work</div>
        <div className="lp-tendering__list-content-detail-bagde">
          {/* {scopeOfWork.map((scope) => ( */}
          <div className="lp-tendering__list-content-detail-bagde-inner">
            <ContentLoader
              style={{
                top: 0,
                left: 0,
                width: "50%",
                height: 45,
              }}
            >
              <rect x="0" y="0" rx={30} ry={30} width="100%" height="100%" />
            </ContentLoader>
          </div>
          {/* ))} */}
        </div>
        <div>Location</div>
        <ContentLoader
          style={{
            top: 0,
            left: 0,
            width: "50%",
            height: 30,
          }}
        >
          <rect x="0" y="0" rx={5} ry={5} width="100%" height="100%" />
        </ContentLoader>
        <div>Style</div>
        <ContentLoader
          style={{
            top: 0,
            left: 0,
            width: "50%",
            height: 30,
          }}
        >
          <rect x="0" y="0" rx={5} ry={5} width="100%" height="100%" />
        </ContentLoader>
      </div>
    );
  };

  return (
    <div className="lp-tendering">
      <div className="lp-tendering__inner">
        <div className="lp-tendering__header">
          <div className="lp-tendering__header__title">Tendering</div>
          <div className="lp-tendering__header__filters">
            {tabs.map((tab) => {
              const isActive = selectedTab === tab.value;

              return (
                <ChoiceChip
                  key={tab.value}
                  label={tab.name}
                  onClick={() => handleTabClick(tab.value)}
                  isSelected={isActive}
                  // width={200}
                  height={24}
                />
              );
            })}
          </div>
          <div style={{ gridArea: "seemore" }}>
            <StylishButton
              label="See more"
              icon={<PlaySvg />}
              onClick={handleClickSeeMore}
              size={"small"}
            />
          </div>
        </div>
        <Swiper
          className="lp-tendering__list"
          modules={[Navigation, Pagination]}
          spaceBetween={24}
          slidesPerView={1}
          slidesPerGroup={1}
          navigation={{
            enabled: true,
            prevEl: ".lp-tendering__footer__arrows--left",
            nextEl: ".lp-tendering__footer__arrows--right",
          }}
          loop={true}
          pagination={{
            el: ".lp-tendering__pagination",
            bulletClass: "lp-tendering__pagination__bullet",
            bulletActiveClass: "lp-tendering__pagination__bullet--active",
            clickable: true,
            renderBullet: function (index, className) {
              return (
                '<span class="' + className + '">' + (index + 1) + "</span>"
              );
            },
          }}
          breakpoints={{
            800: {
              slidesPerView: 2,
              slidesPerGroup: 2,
            },
          }}
        >
          {datasource?.map((data, index) => (
            <SwiperSlide key={index}>
              <TenderingCard data={data} />
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="lp-tendering__footer">
          <ArrowLeftSvg
            className="lp-tendering__footer__arrows lp-tendering__footer__arrows--left"
            width={32}
          />
          <div className="lp-tendering__pagination"></div>
          <ArrowRightSvg
            className="lp-tendering__footer__arrows lp-tendering__footer__arrows--right"
            width={32}
          />
        </div>
      </div>
    </div>
  );
}

export default Tendering;
